import { createFileRoute } from '@tanstack/react-router'
import { EntrarPage } from '@/features/auth/components/EntrarPage'

export const Route = createFileRoute('/_public/entrar')({
  validateSearch: (raw: Record<string, unknown>) => ({
    redirect: typeof raw['redirect'] === 'string' ? raw['redirect'] : undefined,
    code: typeof raw['code'] === 'string' ? raw['code'] : undefined,
    error: typeof raw['error'] === 'string' ? raw['error'] : undefined,
  }),
  component: EntrarRoute,
})

function EntrarRoute() {
  const { redirect, code, error } = Route.useSearch()
  return (
    <EntrarPage
      redirectParam={redirect}
      inviteCode={code}
      authError={error}
    />
  )
}
